import React, { useEffect, useState, useCallback, SetStateAction } from "react";
import { Box, Flex } from "rebass/styled-components";
import styled from "styled-components";
import { useRecoilState } from "recoil";
import { Link } from "../../../Button";
import { feedPlayer, muteState } from "../../../../../globalStorage/autoplay";
import { Player } from "../../../../../components/molecules/clip/player"; // needs to be swapped to mvvm
import { useInView } from "react-intersection-observer";
import { FaPlay } from "react-icons/fa";
import { getSnapshotPath } from "../../../../VideoPlayerOld/utils";
import { ClipControlsSingle } from "../ClipControlsSingle";
import { TransitTime } from "../../../TransitTime";
import { ClipPruned } from "../ClipPruned";
import { TMutateFollowers } from "../../../../Hooks/@types";
import { TPaywallProps } from "../../@types";

type TMobileClipProps = {
  isFeed: boolean;
  autoplay: boolean;
  to: string;
  clip: TClip;
  hideBigPlay: boolean;
  isIos: boolean;
  isMontage: boolean;
  index: number | undefined;
  mutateReaction: (reaction: string) => void;
  followUnfollow: (data: TMutateFollowers) => void;
  setPaywallOpen: ({ open, type }: TPaywallProps) => void;
  setRemixModalOpen: (isOpen: boolean) => void;
  setDownloadModalOpen: (isOpen: boolean) => void;
  setShareModalOpen: (isOpen: boolean) => void;
  setReportModalOpen: (isOpen: boolean) => void;
  setModalOpen: (isOpen: boolean) => void;
  setEditModalOpen: (isOpen: boolean) => void;
  setFollowModal: (isOpen: boolean) => void;
  loading: boolean;
  isProfile: boolean;
  createPrunedClip: () => void;
};
export const MobileClip = ({
  isFeed,
  autoplay,
  to,
  clip,
  hideBigPlay,
  isIos,
  isMontage,
  index,
  mutateReaction,
  followUnfollow,
  setPaywallOpen,
  setRemixModalOpen,
  setDownloadModalOpen,
  setShareModalOpen,
  setReportModalOpen,
  setModalOpen,
  setEditModalOpen,
  setFollowModal,
  loading,
  isProfile,
  createPrunedClip,
}: TMobileClipProps) => {
  const [swappedForVideo, setSwappedForVideo] = useState(!isFeed);
  const [_, setClipDuration] = useState<number | undefined>(); //eslint-disable-line
  const isFirstClip = index === 0;
  const [inViewRef, inView] = useInView({
    threshold: 0.8,
  });
  const [almostInViewRef, almostInView] = useInView({
    rootMargin: "1500px 500px 500px 500px",
  });
  const showTransitTime = ["Queued", "Submitted", "Error"].includes(
    clip.status,
  );
  const clipHasBeenPruned = clip?.status === "Pruned";
  const [shareIdPlaying, setShareIdPlaying] = useRecoilState(feedPlayer);
  const [isMuted] = useRecoilState(muteState);
  const previewThumbnail = getSnapshotPath(clip.clipImageThumb);
  const isRemixed = clip?.remix?.isRemixed;
  const setRefs = useCallback(
    (node) => {
      // Callback refs, like the one from `useInView`, is a function that takes the node as an argument
      inViewRef(node);
      almostInViewRef(node);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [inViewRef],
  );

  useEffect(() => {
    if (inView || !isFeed) {
      setSwappedForVideo(true);
      setShareIdPlaying(clip.shareId);
    } else {
      if (shareIdPlaying === clip.shareId) {
        setSwappedForVideo(false);
      }
    }
  }, [inView]); // eslint-disable-line

  useEffect(() => {
    if (shareIdPlaying !== clip.shareId) {
      setSwappedForVideo(false);
    }
  }, [shareIdPlaying]); // eslint-disable-line

  return (
    <>
      {" "}
      <MainFlex mobileView={true}>
        <LeftFlex snapshot={previewThumbnail}>
          {clipHasBeenPruned || showTransitTime ? (
            <>
              {" "}
              <WidthWrapper>
                {" "}
                <ClipThumbnail snapshot={previewThumbnail} />
                <Centered>
                  {" "}
                  {showTransitTime ? (
                    <Box
                      backgroundColor={"navy"}
                      style={{ borderRadius: "9px" }}
                    >
                      <TransitTime clip={clip._id} />
                    </Box>
                  ) : (
                    <ClipPruned 
                      onClick={createPrunedClip}
                      clipId={clip._id}
                    />
                  )}
                </Centered>
              </WidthWrapper>
            </>
          ) : (
            <VideoFlex>
              <>
                {" "}
                <Box
                  variant="card"
                  name={isFirstClip ? "clip-feed-first-card" : "clip-feed-card"}
                >
                  {" "}
                  <MobileWrapperForSizing ref={setRefs}>
                    <Card
                      $swappedForVideo={swappedForVideo}
                      snapshot={previewThumbnail}
                      name={
                        isFirstClip
                          ? "clip-feed-first-placeholder"
                          : "clip-feed-placeholder"
                      }
                      $shouldShowSnapshot={almostInView}
                      as={swappedForVideo ? undefined : Link}
                      to={swappedForVideo ? null : to}
                    >
                      <>
                        {swappedForVideo ? (
                          <>
                            <StyledPlayer
                              fillScreen={false}
                              index={index}
                              inView={inView}
                              clip={clip}
                              skipBumper={true}
                              muted={isMuted || isIos}
                              loading={false}
                              isRemixed={isRemixed}
                              isFeed={isFeed}
                              mobileView={true}
                              autoplay={autoplay}
                              bigPlayButtonCentered={true}
                              id={clip._id}
                              isMontage={isMontage}
                              hideBigPlay={hideBigPlay}
                              onLoadedMetaData={
                                clip.clipLengthSeconds
                                  ? undefined
                                  : (
                                      duration: SetStateAction<
                                        number | undefined
                                      >,
                                    ) => setClipDuration(duration)
                              }
                            />
                          </>
                        ) : (
                          <PlayButton>
                            <PlayContainer variant="play" size={"small"}>
                              <PlayCircle variant="play.spectrum" />
                              <PlayIcon />
                            </PlayContainer>
                          </PlayButton>
                        )}
                      </>
                    </Card>
                  </MobileWrapperForSizing>
                </Box>{" "}
              </>
            </VideoFlex>
          )}
        </LeftFlex>{" "}
        <ClipControlsSingle
          followUnfollow={followUnfollow}
          setPaywallOpen={setPaywallOpen}
          setRemixModalOpen={setRemixModalOpen}
          setDownloadModalOpen={setDownloadModalOpen}
          setShareModalOpen={setShareModalOpen}
          setReportModalOpen={setReportModalOpen}
          setModalOpen={setModalOpen}
          setEditModalOpen={setEditModalOpen}
          setFollowModal={setFollowModal}
          isProfile={isProfile}
          isFeed={isFeed}
          clip={clip}
          mutateReaction={mutateReaction}
          isMontage={isMontage}
          loading={loading}
        />
      </MainFlex>
    </>
  );
};

const MainFlex = styled<any>(Flex)`
  ${(props) => {
    if (props.isFeed) {
      return `
  width: 100%;
  justify-content: center;
  flex-direction: column;
  gap: 10px;
  
  @media (max-width: ${props.theme.breakpoints[2]}) {
 flex-direction: column;
 `;
    } else {
      return `    
      width: 100%;
      justify-content: center;
      flex-direction: row;
      gap: 10px;
    
      @media (max-width: ${props.theme.breakpoints[2]}) {
        flex-direction: column;
      }`;
    }
  }}
`;

const LeftFlex = styled<any>(Flex)`
  width: 70%;
  justify-content: center;
  border-radius: 10px;
  position: relative;
  @media (max-width: ${(props) => props.theme.breakpoints[2]}) {
    width: 100%;
  }
`;

const WidthWrapper = styled(Box)`
  width: 1150px;
  position: relative;
`;
const ClipThumbnail = styled(Box)<{ snapshot: string | null }>`
  width: 100%;
  position: absolute;
  aspect-ratio: 16/9;
  background-image: url("${({ snapshot }) => snapshot}"),
    url("https://media.allstar.gg/static/fallback.jpg");
  background-size: cover;
  opacity: 0.1;
  z-index: -1;
`;

const Centered = styled(Flex)`
  width: 100%;
  aspect-ratio: 16/9;
  justify-content: center;
  align-items: center;
`;

const VideoFlex = styled(Flex)`
  max-width: 480px;
  width: 100%;
  justify-content: center;
  z-index: 1;
`;
// would like to remove the play button
const PlayButton = styled(Box)`
  display: none;
`;

const MobileWrapperForSizing = styled(Box)`
  max-width: 480px;
  width: 100%;
  position: relative;
`;

const Card = styled<any>(Box)`
  display: block;
  padding-top: 177.77%;
  max-width: 480px;
  width: 100%;
  position: relative;
  overflow: hidden;
  height: 0;
  ${(props) =>
    props.$shouldShowSnapshot
      ? `background-image: url("${props.snapshot}"), url("https://media.allstar.gg/static/fallback.jpg")`
      : null};
  background-size: cover;
`;

const StyledPlayer = styled(Player)`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  overflow: hidden;

  .video-js {
    background-color: transparent;
  }
`;

const PlayCircle = styled(Box)`
  width: 100%;
  backface-visibility: hidden;
  border: 6px;
  border-style: solid;
  border-radius: 50%;
  border-color: ${(props) => props.theme.colors.midnightAlpha90};
`;

const PlayContainer = styled(Box)`
  ${(props: any) => (props.size ? { ...props.theme.play[props.size] } : null)}

  &:hover ${PlayCircle} {
    ${(props: any) => ({ ...props.theme.play.spectrum[":hover"] })}
  }
`;

const PlayIcon = styled(FaPlay)`
  width: 43.75%;
  height: 43.75%;
  position: absolute;
  top: 50%;
  left: 56.25%;
  transform: translateX(-50%) translateY(-50%);
`;
